import {loadStorageData} from "../lib/persistance/storage";
import {SESSION_KEY_DEBUG} from "../lib/constants";

/**
 * Read cookie from the browser context
 * @param name the cookie name
 */
export const getCookie = (name: string): string | null => {
	const v = document?.cookie?.match(`(^|;) ?${name}=([^;]*)(;|$)`);

	return v ? v[2] : null;
};
/**
 * Write a cookie to the browser context
 * @param name the cookie name
 * @param value the value
 * @param path the scope
 * @param expireSeconds time to expiry in seconds
 */
const setCookie = (
	name: string,
	value: string,
	path: string,
	expireSeconds: number
): void => {
	if (!document) {
		return;
	}
	const d = new Date();
	d.setTime(d.getTime() + expireSeconds * 1000);
	document.cookie = `${name}=${value};path=${path};expires=${d.toUTCString()}`;
};

/**
 * Delete a cookie
 * @param name the cookie name
 */
export const deleteCookie = (name: string): void => {
	setCookie(name, '', '/', -1);
};
export const deleteCookieWithName = (name: string): void => {
	const v = document?.cookie?.match(`(^|;) ?${name}=([^;]*)(;|$)`);

	if (null!==v && v!==undefined) {
		if (!!loadStorageData(SESSION_KEY_DEBUG))
			setCookie(v[0], '', '/', -1)
	}
};
